"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTabsLink = void 0;
const react_1 = __importDefault(require("react"));
const PageTabsLink = (props) => {
    const { navigationClassName, LinkComponent, linkRoute, linkSubject, routeKey, isRouteMatch = () => false, } = props;
    const isActive = isRouteMatch(linkRoute || '');
    const isActiveMod = !isActive ? '' : ` ${navigationClassName}__nav-item--active`;
    return (react_1.default.createElement(LinkComponent, { key: `scpsn:route:${routeKey}` },
        react_1.default.createElement("div", { className: `${navigationClassName}__nav-item${isActiveMod}` }, linkSubject)));
};
exports.PageTabsLink = PageTabsLink;
//# sourceMappingURL=index.js.map